import React from 'react';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc';

import TextLength from 'styled/Editor/TextLength';

import DeleteIcon from 'icons/Delete';
import { ReactComponent as BurgerIcon } from 'icons/Burger.svg';
import SimpleButton from 'styled/Buttons/SimpleButton';
import SubBlock from 'styled/Editor/SubBlock';
import PhotoFigure from 'styled/Editor/PhotoFigure';
import FormLabel from 'styled/Editor/FormLabel';
import LeftBlockWrapper from 'styled/Editor/LeftBlockWrapper';

import PhotoBlockWrapper from './PhotoBlockWrapper';
import TextareaStyled from './TextareaStyled';

import BurgerWrapper from './BurgerWrapper';

export class GalleryPhotoBlock extends React.PureComponent {
  handleTitleChange = (e) => {
    this.props.onTitleChange(e.target.value, this.props.order);
  }

  handleDeleteClick = () => {
    this.props.onRemove(this.props.order);
  }

  render() {
    return (
      <PhotoBlockWrapper>
        <LeftBlockWrapper>
          <BurgerWrapper><BurgerIcon /></BurgerWrapper>

          <FormLabel>{this.props.order === 0 ? 'Обложка' : `фото ${this.props.order}`}</FormLabel>

          <PhotoFigure>
            <img
              src={this.props.photoSrc}
              alt={this.props.title}
              width="440"
              height="275"
              style={{ objectFit: 'contain', pointerEvents: 'none' }}
            />

            <figcaption style={{ display: 'flex', alignItems: 'center' }}>
              <TextareaStyled
                value={this.props.title}
                maxLength={140}
                placeholder="Добавьте текст"
                onChange={this.handleTitleChange}
              />

              <TextLength>{this.props.title.length}/140</TextLength>
            </figcaption>
          </PhotoFigure>
        </LeftBlockWrapper>

        <SubBlock style={{ display: 'flex' }}>
          <SimpleButton
            type="button"
            onClick={this.handleDeleteClick}
            style={{ marginTop: 'auto' }}
          >
            <DeleteIcon />
          </SimpleButton>
        </SubBlock>
      </PhotoBlockWrapper>
    );
  }
}

GalleryPhotoBlock.defaultProps = {
  order: 0,
  photoSrc: '',
  title: '',
  onRemove: () => {},
  onTitleChange: () => {},
};

GalleryPhotoBlock.propTypes = {
  order: PropTypes.number,
  photoSrc: PropTypes.string,
  title: PropTypes.string,
  onRemove: PropTypes.func,
  onTitleChange: PropTypes.func,
};

export default SortableElement(GalleryPhotoBlock);
